import { createContext, useContextSelector } from 'use-context-selector';

const GlobalStateCS = createContext(null);
const useGlobalStateSelector = (selector) => useContextSelector(GlobalStateCS, selector);


export {
  GlobalStateCS,
  useGlobalStateSelector,
};
